import { Injectable } from "@angular/core";
import 'rxjs/Rx';
import { Globals } from "../../globals";
import { AdminService } from "../admin/AdminService";
import { ToastrService } from "ngx-toastr";
import { setTimeout } from "timers";
import { saveAs } from 'file-saver';

@Injectable()
export class DownloadAssessmentManager {
    parent: any;

    constructor(
        private _AdminService: AdminService,
        private _Globals: Globals,
        private _toastr: ToastrService) { }

    downloadReport(clientId: number, assignmentId: number, userType: number, parent:any) {
        $('body').css('cursor', 'wait');
        this.parent = parent;
        this._AdminService.getAssessmentReport(clientId, assignmentId, userType)
            .subscribe((data: any) => {
                console.log('response_getAssessmentReport', data);

                if (this._Globals.validationToken(data.Result)) {
                    if (data.Result == 1) {
                        let _data = JSON.parse(data.Data);
                        let fileName = _data.ReportName;
                        let base64File = _data.ReportData;

                        this.base64ToBlob(base64File, fileName);

                        if (this.parent.from != "manage_assessments_assigned") this.parent.reportGenerated = true;
                    } else {
                        this._toastr.error('We are sorry. An error happened when trying to download the report.', 'ELI');

                        if (this.parent.ngProgress) {
                            this.parent.finish = true;
                            this.parent.ngProgress.ref().complete();
                            $('body').css('cursor', 'default');
                        }
                    }
                    
                } 

            });
    }


    base64ToBlob(str: any, fileName: string, type = 'application/pdf') {
        // decode base64
        var content = atob(str);

        // create an ArrayBuffer and a view (as unsigned 8-bit)
        var buffer = new ArrayBuffer(content.length);
        var view = new Uint8Array(buffer);

        // fill the view, using the decoded base64
        for (var n = 0; n < content.length; n++) {
            view[n] = content.charCodeAt(n);
        }

        // convert ArrayBuffer to Blob
        //var blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document" });
        //var blob = new Blob([buffer], { type: "application/pdf" });
        //var FileSaver = require('file-saver');
        //var file = new File([buffer], fileName, { type: "application/pdf" });
        //var file = new Blob([buffer], { type: 'image/jpeg' });

        this.saveFile(fileName, buffer, type);

        //FileSaver.saveAs(file);
        if (this.parent){
            if (this.parent.finish !== undefined) {
                this.parent.finish = true;
            }
    
            if(this.parent.ngProgress) {
                this.parent.ngProgress.ref().complete();
            }
        } 
        
        //setTimeout(() => {
        //client mode
        if (this._Globals.loadPageContentClientResults) {
            this.parent.getAssessmentPageByUserType();
            this._Globals.loadPageContentClientResults = false;
        }
        $('body').css('cursor', 'default');

        //this.blobToFile(blob, fileName);
    }


    saveFile(name: any, data: any, type = 'application/pdf') {
        if (data != null && navigator.msSaveBlob)
            return navigator.msSaveBlob(new Blob([data], { type: type }), name);
        var a = $("<a style='display: none;'/>");
        var url = window.URL.createObjectURL(new Blob([data], { type: type }));
        a.attr("href", url);
        a.attr("download", name);
        $("body").append(a);
        a[0].click();
        window.URL.revokeObjectURL(url);
        a.remove();
    }


    blobToFile  (theBlob: Blob, fileName: string) {
        var b: any = theBlob;
        //A Blob() is almost a File() - it's just missing the two properties below which we will add
        b.lastModifiedDate = new Date();
        b.name = fileName;

        console.log('this.parent.constructor.name', this.parent.constructor.name);

        if (this.parent.ngProgress) {
            this.parent.finish = true;
            this.parent.ngProgress.ref().complete();
            //setTimeout(() => {
            //client mode
            if (this._Globals.loadPageContentClientResults) {
                this.parent.getAssessmentPageByUserType();
                this._Globals.loadPageContentClientResults = false;
            }
           // }, 1000);
            
        //    this.parent.reportGenerated = true;
        }

       

        //if (this.parent.constructor.name == "CoachAssessmentReportComponent") {
            //console.log('CoachAssessmentReportComponent');
            //this.parent.finish = true;
            //this.parent.ngProgress.done();
            //    this.parent.generatingReport = false;
        //}

        //Cast to a File() type
        console.log('b', b);
        var anchor = document.createElement('a');
        anchor.download = fileName;
        anchor.href = (window.URL).createObjectURL(b);
        //anchor.dataset.downloadurl = ['application/vnd.openxmlformats-officedocument.wordprocessingml.document', anchor.download, anchor.href].join(':');
        anchor.dataset.downloadurl = ['application/pdf', anchor.download, anchor.href].join(':');
        console.log('anchor', anchor);

        anchor.click();  
        $('body').css('cursor', 'default');
        
        //var url = URL.createObjectURL(b);
        //window.open(url);
        //window.location.href = url;
    }

}